/* Art by Maria P — theme behaviour (vanilla JS, no dependencies) */
(function () {
  document.documentElement.classList.remove('no-js');

  const routes = (window.theme && window.theme.routes) || {
    cart_add_url: '/cart/add', cart_change_url: '/cart/change', cart_url: '/cart'
  };

  /* ---------- Reveal on scroll ---------- */
  const revealObserver = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) { e.target.classList.add('is-visible'); revealObserver.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -50px 0px' })
    : null;
  function initReveal(root) {
    root.querySelectorAll('.reveal:not(.is-visible)').forEach((el) => {
      revealObserver ? revealObserver.observe(el) : el.classList.add('is-visible');
    });
  }
  initReveal(document);

  /* ---------- Mobile menu ---------- */
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const mobileMenu = document.getElementById('MobileMenu');
  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', () => {
      const open = mobileMenu.hidden;
      mobileMenu.hidden = !open;
      menuToggle.setAttribute('aria-expanded', String(open));
    });
  }

  /* ---------- Cart drawer ---------- */
  const body = document.body;
  function openDrawer() {
    if (!document.getElementById('CartDrawer')) { window.location.href = routes.cart_url; return; }
    body.classList.add('drawer-open');
    const close = document.querySelector('#CartDrawer [data-drawer-close]');
    if (close) close.focus();
  }
  function closeDrawer() { body.classList.remove('drawer-open'); }

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); openDrawer(); }
    if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); closeDrawer(); }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawer(); });

  function setCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.hidden = count < 1;
      el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump');
    });
  }

  // Swap freshly rendered cart-drawer section HTML into the page
  function renderSections(sections) {
    if (!sections) return;
    const html = sections['cart-drawer'];
    if (html) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('#CartDrawerInner');
      const current = document.getElementById('CartDrawerInner');
      if (fresh && current) current.replaceWith(fresh);
      const countEl = doc.querySelector('[data-cart-item-count]');
      if (countEl) setCount(parseInt(countEl.dataset.cartItemCount, 10) || 0);
    }
  }

  async function changeLine(key, quantity) {
    const drawer = document.getElementById('CartDrawerInner');
    if (drawer) drawer.classList.add('is-loading');
    try {
      const res = await fetch(routes.cart_change_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity, sections: ['cart-drawer'], sections_url: window.location.pathname })
      });
      const data = await res.json();
      if (document.querySelector('[data-cart-page]')) { window.location.reload(); return; }
      renderSections(data.sections);
    } finally {
      const d = document.getElementById('CartDrawerInner');
      if (d) d.classList.remove('is-loading');
    }
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-line-change]');
    if (!btn) return;
    e.preventDefault();
    changeLine(btn.dataset.key, parseInt(btn.dataset.quantity, 10));
  });

  /* ---------- Product form (AJAX add to cart) ---------- */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-product-form]');
    if (!form || !document.getElementById('CartDrawer')) return;
    e.preventDefault();
    const button = form.querySelector('[type="submit"]');
    const error = form.querySelector('[data-form-error]');
    const label = button.textContent;
    button.disabled = true;
    if (error) error.hidden = true;
    const fd = new FormData(form);
    fd.append('sections', 'cart-drawer');
    fd.append('sections_url', window.location.pathname);
    try {
      const res = await fetch(routes.cart_add_url + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || 'Could not add to cart');
      renderSections(data.sections);
      button.textContent = 'Added!';
      setTimeout(() => { button.textContent = label; }, 2000);
      openDrawer();
    } catch (err) {
      if (error) { error.textContent = err.message; error.hidden = false; }
    } finally {
      button.disabled = false;
    }
  });

  /* ---------- Variant picker ---------- */
  function initVariantPickers(root) {
  root.querySelectorAll('[data-variant-picker]').forEach((picker) => {
    const section = picker.closest('[data-product-section]');
    const dataEl = section.querySelector('[data-variants-json]');
    if (!dataEl) return;
    const variants = JSON.parse(dataEl.textContent);
    const idInput = section.querySelector('input[name="id"]');
    const priceEl = section.querySelector('[data-price]');
    const button = section.querySelector('[data-add-button]');

    function selected() {
      return Array.from(picker.querySelectorAll('fieldset')).map((fs) => {
        const checked = fs.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }

    function markUnavailable(current) {
      picker.querySelectorAll('fieldset').forEach((fs, idx) => {
        fs.querySelectorAll('input').forEach((input) => {
          const test = current.slice(); test[idx] = input.value;
          const match = variants.find((v) => v.options.every((o, i) => o === test[i]));
          input.classList.toggle('is-unavailable', !match || !match.available);
        });
      });
    }

    function update() {
      const opts = selected();
      const variant = variants.find((v) => v.options.every((o, i) => o === opts[i]));
      markUnavailable(opts);
      if (!variant) {
        button.disabled = true; button.textContent = 'Unavailable';
        return;
      }
      idInput.value = variant.id;
      priceEl.innerHTML = variant.price + (variant.compare_at ? ' <s>' + variant.compare_at + '</s>' : '');
      button.disabled = !variant.available;
      button.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    picker.addEventListener('change', update);
    markUnavailable(selected());
  });
  }
  initVariantPickers(document);

  /* ---------- Shirt switcher: swap the product section in place (Section Rendering API), no reload/jump ---------- */
  const shirtCache = new Map();
  function shirtFetch(href, sectionId) {
    const url = new URL(href, window.location.href);
    url.searchParams.set('section_id', sectionId);
    const key = url.toString();
    if (!shirtCache.has(key)) shirtCache.set(key, fetch(key).then((r) => { if (!r.ok) throw new Error(r.status); return r.text(); }));
    return shirtCache.get(key);
  }
  function shirtSection(link) {
    const wrap = link.closest('.shopify-section');
    return wrap ? { wrap, id: wrap.id.replace('shopify-section-', '') } : null;
  }
  document.addEventListener('pointerover', (e) => {
    const link = e.target.closest('.shirt-switch a[href]');
    const s = link && shirtSection(link);
    if (s) shirtFetch(link.href, s.id).catch(() => {});
  });
  document.addEventListener('click', async (e) => {
    const link = e.target.closest('.shirt-switch a[href]');
    if (!link || e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
    const s = shirtSection(link);
    if (!s) return;
    e.preventDefault();
    s.wrap.setAttribute('aria-busy', 'true');
    try {
      const html = await shirtFetch(link.href, s.id);
      const fresh = new DOMParser().parseFromString(html, 'text/html').getElementById(s.wrap.id);
      if (!fresh) throw new Error('no section');
      const y = window.scrollY;
      fresh.querySelectorAll('.reveal').forEach((el) => el.classList.add('is-visible'));
      s.wrap.innerHTML = fresh.innerHTML;
      window.scrollTo(0, y);
      initVariantPickers(s.wrap);
      initBackLinks(s.wrap);
      const title = s.wrap.querySelector('.product__title');
      if (title) document.title = title.textContent.trim() + ' – ' + document.title.split(' – ').pop();
      window.history.replaceState({}, '', link.href);
    } catch (err) {
      window.location.href = link.href;
    } finally {
      s.wrap.removeAttribute('aria-busy');
    }
  });

  /* ---------- Product media thumbnails ---------- */
  function showMedia(section, id) {
    const items = section.querySelectorAll('[data-media-id]');
    if (!Array.from(items).some((m) => m.dataset.mediaId === id)) return;
    items.forEach((m) => { m.hidden = m.dataset.mediaId !== id; });
    section.querySelectorAll('[data-thumb]').forEach((t) => t.setAttribute('aria-current', String(t.dataset.thumb === id)));
  }
  document.addEventListener('click', (e) => {
    const thumb = e.target.closest('[data-thumb]');
    if (!thumb) return;
    showMedia(thumb.closest('[data-product-section]'), thumb.dataset.thumb);
  });

  /* ---------- Shop search + price filter (client-side, current page) ---------- */
  document.querySelectorAll('[data-shop-filter]').forEach((root) => {
    const search = root.querySelector('[data-shop-search]');
    const chips = root.querySelectorAll('[data-price-chip]');
    const cards = root.querySelectorAll('[data-card]');
    const empty = root.querySelector('[data-empty]');
    let range = 'all';
    function apply() {
      const q = (search ? search.value : '').trim().toLowerCase();
      let shown = 0;
      cards.forEach((card) => {
        const price = parseFloat(card.dataset.price) / 100;
        const title = card.dataset.title || '';
        let ok = !q || title.includes(q);
        if (range === 'under50') ok = ok && price < 50;
        if (range === '50to100') ok = ok && price >= 50 && price <= 100;
        if (range === 'over100') ok = ok && price > 100;
        card.hidden = !ok;
        if (ok) shown++;
      });
      if (empty) empty.hidden = shown > 0;
    }
    if (search) search.addEventListener('input', apply);
    chips.forEach((chip) => chip.addEventListener('click', () => {
      range = chip.dataset.priceChip;
      chips.forEach((c) => c.setAttribute('aria-pressed', String(c === chip)));
      apply();
    }));
  });

  /* ---------- Carousel (murals) ---------- */
  document.querySelectorAll('[data-carousel]').forEach((root) => {
    const slides = root.querySelectorAll('.carousel__slide');
    const dots = root.querySelectorAll('.carousel__dot');
    if (slides.length < 2) return;
    let current = 0;
    function go(i) {
      current = (i + slides.length) % slides.length;
      slides.forEach((s, idx) => s.classList.toggle('is-active', idx === current));
      dots.forEach((d, idx) => d.setAttribute('aria-current', String(idx === current)));
    }
    root.querySelector('[data-prev]').addEventListener('click', () => go(current - 1));
    root.querySelector('[data-next]').addEventListener('click', () => go(current + 1));
    dots.forEach((d, idx) => d.addEventListener('click', () => go(idx)));
  });

  /* ---------- Back link: return to the exact listing (scroll position, search, filters) ---------- */
  function initBackLinks(root) {
  root.querySelectorAll('[data-back-link]').forEach((link) => {
    link.addEventListener('click', (e) => {
      try {
        const ref = new URL(document.referrer);
        const target = new URL(link.href, window.location.href);
        if (ref.origin === window.location.origin && ref.pathname === target.pathname && window.history.length > 1) {
          e.preventDefault();
          window.history.back();
        }
      } catch (err) { /* no referrer — follow the link */ }
    });
  });
  }
  initBackLinks(document);

  /* ---------- Masonry: fill columns so the collection order reads left-to-right across rows ---------- */
  function layoutMasonry(el) {
    if (!el._items) el._items = Array.from(el.querySelectorAll(':scope > .masonry__item'));
    const w = window.innerWidth;
    const n = w >= 1024 ? 3 : w >= 640 ? 2 : 1;
    if (el._cols === n) return;
    el._cols = n;
    el.querySelectorAll(':scope > .masonry__col').forEach((c) => c.remove());
    if (n === 1) { el.classList.remove('masonry--cols'); el._items.forEach((it) => el.appendChild(it)); return; }
    const cols = Array.from({ length: n }, () => { const c = document.createElement('div'); c.className = 'masonry__col'; el.appendChild(c); return c; });
    el._items.forEach((it, i) => cols[i % n].appendChild(it));   // strict row order: 1 2 3 / 4 5 6 ...
    el.classList.add('masonry--cols');
  }
  const masonries = document.querySelectorAll('.masonry');
  masonries.forEach(layoutMasonry);
  if (masonries.length) window.addEventListener('resize', () => masonries.forEach(layoutMasonry));


  /* ---------- Explore accordion: smooth open/close, one item open at a time ---------- */
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function animateDetails(details, open) {
    const summary = details.querySelector('summary');
    if (details._anim) details._anim.cancel();
    const start = details.offsetHeight;
    if (open) details.open = true;
    const end = open ? details.scrollHeight : summary.offsetHeight + 2;
    if (reduceMotion) { if (!open) details.open = false; return; }
    details.classList.toggle('is-closing', !open);
    details._anim = details.animate({ height: [start + 'px', end + 'px'] }, { duration: 380, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' });
    details._anim.onfinish = () => { details._anim = null; details.classList.remove('is-closing'); if (!open) details.open = false; details.style.height = ''; };
  }
  document.querySelectorAll('.explore__list').forEach((list) => {
    list.querySelectorAll('details.explore__item > summary').forEach((summary) => {
      summary.addEventListener('click', (e) => {
        e.preventDefault();
        const details = summary.parentElement;
        const opening = !details.open || details.classList.contains('is-closing');
        if (opening) list.querySelectorAll('details.explore__item[open]').forEach((d) => { if (d !== details) animateDetails(d, false); });
        animateDetails(details, opening);
      });
    });
  });

  /* Re-init when sections are edited in the theme editor */
  document.addEventListener('shopify:section:load', (e) => initReveal(e.target));
})();
